import { Injectable } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { DispatchHardware } from './dispatch-hardware.component';
import { InvestigoDrive } from '../../insurgo-classes/investigo-drive.class';
import { InvestigoScanner } from '../../insurgo-classes/investigo-scanner.class';


@Injectable({
  providedIn: 'root',
})
export class DispatchHardwareService {

  constructor(
    private dialogService: NbDialogService
  ) { }

  show(selectedDispatchDrives: InvestigoDrive[], selectedDispatchScanners: InvestigoScanner[]): Promise<string> {
    const modal = this.dialogService.open(DispatchHardware, {
      closeOnBackdropClick: true,
      context: {
        selectedDrives: selectedDispatchDrives,
        selectedScanners: selectedDispatchScanners
      }
    });
    return new Promise<string>((resolve, reject) => {
      modal.onClose.subscribe((result) => {
        resolve(result);
      });
    });
  }
}
